<template lang="pug">
  dialogs(:show.sync="visible" :option="{ size: 'ml' }" :title="this.$t('management_page.windows_antivirus_check_settings')")
    .form
      b-row
        b-col.d-flex.align-items-center(cols="4" v-html="$t('management_page.antivirus_process_name_excluding_exe')" )
        b-col.d-flex.align-items-center(cols="8")
          b-form-input(v-model="form.value" size="sm")
      b-row
        b-col.d-flex.align-items-center(cols="12")
          span {{$t('management_page.antivirus_detection_by_process')}}

    .modal-footer
      b-btn(size="sm" @click="visible = false" pill) {{$t('cancel')}}
      b-btn(size="sm" variant="primary" @click="submit" pill) {{$t('save')}}
</template>

<script>
import { CompanyFunctionAPI } from "@/api"
import Dialogs from "@/components/mixins/dialog/index.vue"
import _ from "lodash"

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "",
    },
  },
  components: {
    Dialogs,
  },
  watch: {
    show(newVal) {
      this.visible = newVal
      if (newVal) {
        this.form.value = this.value
      }
    },
    visible(newVal) {
      this.$emit("update:show", newVal)
    },
  },
  data() {
    return {
      visible: false,
      form: {
        request_type: "vaccine",
        value: "",
      },
    }
  },
  methods: {
    submit() {
      const params = _.cloneDeep(this.form)
      CompanyFunctionAPI.put("", params).then(res => {
        const { status } = res
        if (status === 200) {
          this.$awn.success(String(this.$t('toasts_message.save_success')))
          this.$emit("update:value", this.form.value)
          this.$emit("update:show", false)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.form {
  padding: 10px 30px;
}
</style>
